import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import classNames from 'classnames';
import HelpTooltip from '../controls/helpTooltip';
import styles from './styles.scss';

export default class PortalDropdown extends Component {

    defaultLabelColor = '#444444';
    optinalLabelColor = '#9b9b9b';
    errorColor = '#d82943';

    render() {

        const { defaultOptionalValue } = this.props;
        
        const textboxBottomFocus = this.defaultLabelColor;
        const textboxBottomDisable = this.optinalLabelColor;

        const listStyle = {
            color: textboxBottomFocus
        };

        const selectedMenuItemStyle = {
            color: '#4a90e2'
        };
        
        const underlineDisabledStyle = {
            borderBottom: `1px solid ${textboxBottomDisable}`,
            cursor: 'initial'
        };
       
        const errorStyle = {
            float: 'left',
            fontSize: '13px',
            color: '#D0021B'
        };
        
        return (
            <div
                className={styles.portalDropdownWrapper}
                style={{
                    width: this.props.width
                }}
                data-cy={this.props.dataCy}
            >
                <SelectField
                    listStyle={listStyle}
                    maxHeight={250}
                    selectedMenuItemStyle={selectedMenuItemStyle}
                    className={
                        classNames(
                            styles.portalDropdown,
                            this.props.errorText && 'error'
                        )}
                    floatingLabelText={this.props.floatingLabelText}
                    floatingLabelStyle={{
                        color: this.props.errorText ? this.errorColor : this.optinalLabelColor
                    }}
                    onChange={this.props.onChange}
                    value={this.props.value}
                    style={{
                        width: '100%'
                    }}
                    underlineDisabledStyle={underlineDisabledStyle}
                    fullWidth = {this.props.fullWidth}
                    disabled={this.props.disabled}
                    errorText={this.props.errorText}
                    errorStyle={errorStyle}
                    autoComplete={'new-password' || this.props.autoComplete}
                >
                    
                    {this.props.items.map(item => {

                        return (
                            <MenuItem 
                                key={item.id}
                                value={item.id}
                                primaryText={item.text || item.name}
                                innerDivStyle={{color: item.id == (defaultOptionalValue || -1) ? this.optinalLabelColor : this.defaultLabelColor}}
                            />
                        );
                    })}

                </SelectField>
                {
                    this.props.helpTooltipText !== undefined ? 
                        <HelpTooltip displayInline text={this.props.helpTooltipText} /> : null
                }
            </div>
        );
    }
}